/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svr_Onsite_Protocol_PlaceholderInputs */

const en_svr_onsite_protocol_placeholder = /** @type {(inputs: Svr_Onsite_Protocol_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe the work done on-site, status of the visit, any revisit needs, tools/cabling/parts, required skills, site access issues, Accenture FOT POC, overtime and reasons, etc.`)
};

const ja_svr_onsite_protocol_placeholder = /** @type {(inputs: Svr_Onsite_Protocol_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現場での作業内容、訪問状況、再訪問の必要性、工具・配線・部品、必要なスキル、アクセス問題、Accenture FOT担当者、残業とその理由などを記述してください。`)
};

const fr_svr_onsite_protocol_placeholder = /** @type {(inputs: Svr_Onsite_Protocol_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décrivez les travaux effectués sur site, l'état de la visite, les besoins de revisites, outils/câblage/pièces, compétences requises, problèmes d'accès, POC Accenture FOT, heures supplémentaires et raisons, etc.`)
};

const de_svr_onsite_protocol_placeholder = /** @type {(inputs: Svr_Onsite_Protocol_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreiben Sie die vor Ort durchgeführten Arbeiten, Status des Besuchs, Bedarf an erneutem Besuch, Werkzeuge/Verkabelung/Teile, erforderliche Fähigkeiten, Zugangsprobleme, Accenture FOT-Ansprechpartner, Überstunden und Gründe, etc.`)
};

/**
* | output |
* | --- |
* | "Describe the work done on-site, status of the visit, any revisit needs, tools/cabling/parts, required skills, site access issues, Accenture FOT POC, overtime..." |
*
* @param {Svr_Onsite_Protocol_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const svr_onsite_protocol_placeholder = /** @type {((inputs?: Svr_Onsite_Protocol_PlaceholderInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svr_Onsite_Protocol_PlaceholderInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_svr_onsite_protocol_placeholder(inputs)
	if (locale === "ja") return ja_svr_onsite_protocol_placeholder(inputs)
	if (locale === "fr") return fr_svr_onsite_protocol_placeholder(inputs)
	return de_svr_onsite_protocol_placeholder(inputs)
});